import { endOfWeek, startOfWeek } from 'date-fns';
import { PaymentPlanFilterType, PaymentPlanStatus } from '@frontend/api-payment-plans';
import { usePaymentPlanShallowStore } from '../../providers/payment-plans-provider';
import { getPaymentPlanFilterRange } from '../../utils/date-helpers';
import { DefaultFilters, useQuickFilters } from '../utils/use-quick-filters';

export type PlanQuickFilterTypes =
  | 'weekFilter'
  | 'needsActionFilter'
  | 'pausedStatusFilter'
  | 'completedStatusFilter'
  | 'all';

export const usePaymentPlanQuickFilters = () => {
  const { filter, setFilter, clearFilters } = usePaymentPlanShallowStore('filter', 'setFilter', 'clearFilters');
  const defaultFilters: DefaultFilters<PlanQuickFilterTypes, PaymentPlanFilterType> = {
    weekFilter: {
      nextPaymentAt: getPaymentPlanFilterRange([startOfWeek(Date.now()), endOfWeek(Date.now())]),
    },
    needsActionFilter: {
      status: [PaymentPlanStatus.Failed],
    },
    pausedStatusFilter: {
      status: [PaymentPlanStatus.Paused],
    },
    completedStatusFilter: {
      status: [PaymentPlanStatus.Completed],
    },
    all: {},
  };

  const { isFilterActive, handleQuickFilter } = useQuickFilters({ defaultFilters, filter, onChange: setFilter });

  return { defaultFilters, isFilterActive, handleQuickFilter, clearFilters };
};
